export const LOGGER_TYPES = {
  ANALYTICS_GOOGLE: 'ANALYTICS_GOOGLE',
  ANALYTICS_BI: 'ANALYTICS_BI',
  FEDOPS: 'FEDOPS',
};
